import React from "react";
import ScroolTableAddPro from "./ScroolTableAddPro";
import { ProductConsumer } from "../../../Context/AddProWakel";
import _ from "lodash";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

const AddProductSecond = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            edit,
            AddProChange,
            DarzanChange,
            darzan,
            updtae_product,
            Add_rasidkarton,
            del_dis,
            karton,
            onSaveTable,
            prodactdata,
            clear_edit,
            CartonChange,
            productpageminsone,
            productpageplusone,
            width,
            height,
            length,
            aynamictoanotherInput,
            meterPrice,
            metercheck,
            MeterTogler,
            MerterChange,
            remembiPrice,
            zhmarayDwkan,
            dnk,
            KoyGshtyR,
            KoyGshtydolar_,
            priceOneRRR,
            addnrxKraton,
            calculateNrxDarzan,
            kren,
            qazanj,
            nrxeFroshtnDolar,
            nrxifroshtnkarton,
            KM_onchangeSalePer,
            P_calculateProfit,
            data,
            nsbayfrohtn,
            nrxifroshtnkarton2,
            nsbayfrohtn2,
            qazanj2,
            nrxeFroshtnDolar2,
            nrxifroshtnkarton2_IQD,
            nsbayfrohtn2_IQD,
            qazanj2_IQD,
            nrxeFroshtnDenar2,
            P_getListUpdatedItems,
            Chine_invoice,
            dp,
            P_meterPrice,
            P_remembiPrice,
            zhmarayKarton
          } = value;
          return (
            <>
              <form>
                <div className="mt1">
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-3 text-right px-1 ">
                      <div className="row">
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">کاڵا- RR</label>
                            <input
                              type="text"
                               disabled={del_dis == true ? true : null}
                              value={
                                P_remembiPrice 
                              }
                              onChange={AddProChange}
                              name="P_remembiPrice"
                              className="form-control text-right f3 font-weight-bold bg-warning text-black"
                            />
                          </div>
                        </div>
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">
                             کاڵا-  مەتر
                            </label>
                            <input
                              type="text"
                               disabled={del_dis == true ? true : null}
                              value={P_meterPrice }
                              onChange={AddProChange}
                              name="P_meterPrice"
                              className="form-control text-right f3 font-weight-bold bg-warning text-black"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">ژ.پ.سین</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={Chine_invoice}
                          name="Chine_invoice"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 9, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-success text-white"
                        />
                      </div>
                    </div>

                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">ژ.دووکان</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={zhmarayDwkan}
                          name="zhmarayDwkan"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 1, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-success text-white"
                        />
                      </div>
                    </div>
                    <div className="col-3 text-right px-1 ">
                      <div className="row">
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">نرخی RR</label>
                            <input
                              type="text"
                              disabled={metercheck == false ? true : null}
                              onChange={(e) => AddProChange(e)}
                              value={ remembiPrice }
                              name="remembiPrice"
                              className="form-control text-right f3 font-weight-bold bg-success text-white"
                            />
                          </div>
                        </div>
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">
                              نرخی مەتر
                            </label>
                            <input
                              type="text"
                              disabled={metercheck == false ? true : null}
                              onChange={(e) => AddProChange(e)}
                              value={meterPrice }
                              name="meterPrice"
                              className="form-control text-right f3 font-weight-bold bg-success text-white"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 mt4 text-right px-1 ">
                      {metercheck ? (
                        <button
                          onClick={MeterTogler}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-check"></i>
                        </button>
                      ) : (
                        <button
                          onClick={MeterTogler}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-times-circle"></i>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1"></div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label
                          className="font-weight-bold text-warning"
                          style={{ fontSize: "16px" }}
                        >
                          P-|-D{" "}
                        </label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={dp}
                          name="dp"
                          style={{
                            height: "45px",
                            backgroundColor: "#17a2b8",
                            border: "2px solid #ffc107",
                            fontSize: "18px",
                            fontWeight: "bold"
                          }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 16, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1 ">
                      <div className="form-group">
                        <label className="font-weight-bold">$کۆی گشتی</label>
                        <input
                          type="text"
                          disabled={del_dis == true ? true : null}
                          value={Number(KoyGshtydolar_()).toFixed(2)}
                          name="length"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 5, "p")
                              : null
                          }
                          autoComplete="off"
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">Rکۆی گشتی</label>
                        <input
                          type="text"
                          value={Number(KoyGshtyR()).toFixed(2)}
                          name="techw"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 6, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          نرخی یەک دانە
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="priceOneRRR"
                          disabled={del_dis == true ? true : null}
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 8, "p")
                              : null
                          }
                          value={priceOneRRR}
                          onChange={AddProChange}
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">عدد کارتۆن</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={dnk}
                          name="dnk"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 11, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1 mt-5">
                      <Link to="/PriceUpdate" onClick={P_getListUpdatedItems}>
                        <span className="btn btn-md btn-warning">
                          گۆڕانکاری لە نرخ
                        </span>
                      </Link>
                    </div>
                     <div className="col-2 text-right px-1 mt-5"></div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">تێچوی مەتر</label>
                        <input
                          type="text"
                          value={Number(MerterChange()).toFixed(2)}
                          name="techw"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 22, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">پانی</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={width}
                          name="width"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 13, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">بەرزی</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={height}
                          name="height"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 14, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1 ">
                      <div className="form-group">
                        <label className="font-weight-bold">درێژی</label>
                        <input
                          type="text"
                          disabled={del_dis == true ? true : null}
                          onChange={(e) => AddProChange(e)}
                          value={length}
                          name="length"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 15, "p")
                              : null
                          }
                          autoComplete="off"
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">٪فرۆشتن</label>
                        <input
                          type="text"
                          onChange={(e) => KM_onchangeSalePer(e, "nsbayfrohtn")}
                          value={nsbayfrohtn}
                          name="nsbayfrohtn"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 26, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">1 ك $$$$</label>
                        <input
                          type="text"
                          onChange={(e) => KM_onchangeSalePer(e, "qazanj")}
                          value={qazanj}
                          name="qazanj"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 17, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          $ نرخی فرۆشتن
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            KM_onchangeSalePer(e, "nrxeFroshtnDolar")
                          }
                          value={nrxeFroshtnDolar}
                          name="nrxeFroshtnDolar"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 18, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          {" "}
                          $ فرۆشتن کارتۆن
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            KM_onchangeSalePer(e, "nrxifroshtnkarton")
                          }
                          value={nrxifroshtnkarton}
                          name="nrxifroshtnkarton"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 19, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">$$$</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={kren}
                          name="kren"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 20, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1 ">
                      <div className="form-group">
                        <label className="font-weight-bold">نرخی کارتۆن</label>
                        <input
                          type="text"
                          disabled={del_dis == true ? true : null}
                          value={addnrxKraton}
                          onChange={calculateNrxDarzan}
                          name="addnrxKraton"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 21, "p")
                              : null
                          }
                          autoComplete="off"
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">2٪فرۆشتن</label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "nsbayfrohtn2",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "nsbayfrohtn2");
                          }}
                          value={nsbayfrohtn2}
                          name="nsbayfrohtn2"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 8, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">1 ك $$$$2</label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "qazanj2",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "qazanj2");
                          }}
                          value={qazanj2}
                          name="qazanj2"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 23, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          2$ نرخی فرۆشتن
                        </label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "nrxeFroshtnDolar2",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "nrxeFroshtnDolar2");
                          }}
                          value={nrxeFroshtnDolar2}
                          name="nrxeFroshtnDolar2"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 24, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          {" "}
                          2$ فرۆشتن کارتۆن
                        </label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "nrxifroshtnkarton2",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "nrxifroshtnkarton2");
                          }}
                          value={nrxifroshtnkarton2}
                          name="nrxifroshtnkarton2"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 25, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1"></div>
                    <div className="col-2 text-right px-1 "></div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">2٪فرۆشتن</label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "nsbayfrohtn2_IQD",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "nsbayfrohtn2_IQD");
                          }}
                          value={nsbayfrohtn2_IQD}
                          name="nsbayfrohtn2_IQD"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 10, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-warning text-dark"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">1 ك ID2</label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "qazanj2_IQD",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "qazanj2_IQD");
                          }}
                          value={qazanj2_IQD}
                          name="qazanj2_IQD"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 24, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-warning text-dark"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-3 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                            {P_calculateProfit(nrxeFroshtnDenar2,kren,zhmarayKarton)||0}
                          2ID نرخی فرۆشتن
                        </label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "nrxeFroshtnDenar2",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "nrxeFroshtnDenar2");
                          }}
                          value={nrxeFroshtnDenar2}
                          name="nrxeFroshtnDenar2"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 25, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-warning text-dark"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-3 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          2ID فرۆشتن کارتۆن
                        </label>
                        <NumberFormat
                          type="text"
                          onValueChange={(values) => {
                            const event = {
                              target: {
                                name: "nrxifroshtnkarton2_IQD",
                                value: values.value
                              }
                            };
                            KM_onchangeSalePer(event, "nrxifroshtnkarton2_IQD");
                          }}
                          value={nrxifroshtnkarton2_IQD}
                          name="nrxifroshtnkarton2_IQD"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 26, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-warning text-dark"
                          thousandSeparator={true}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1"></div>
                    <div className="col-2 text-right px-1 "></div>
                  </div>
                </div>
              </form>
              <div className="mt5">
                <div className="row  f4" style={{ color: "#000C66" }}>
                  <div className="col-1 text-right px-2 mt4">
                    {edit == null ? (
                      <button
                        onClick={() => onSaveTable(prodactdata)}
                        className="btn btn-success"
                      >
                        <i className="far fa-save"></i>
                      </button>
                    ) : (
                      <button
                        onClick={() => updtae_product(edit._id)}
                        className="btn btn-primary"
                      >
                        <i className="far fa-edit"></i>
                      </button>
                    )}
                  </div>
                  <div className="col-2 text-right px-1">
                    <div className="form-group">
                      <label className="font-weight-bold">رەسید کارتۆن</label>
                      <input
                        type="text"
                        value={Add_rasidkarton}
                        name="Add_rasidkarton"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-2 text-right px-1 ">
                    <div className="form-group">
                      <label className="font-weight-bold">دەرزەن</label>
                      <input
                        type="text"
                        disabled={del_dis == true ? true : null}
                        onChange={(e) => DarzanChange(e)}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? edit == null
                              ? onSaveTable(event)
                              : updtae_product(edit._id)
                            : null
                        }
                        value={darzan}
                        name="darzan"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>

                  <div className="col-2 text-right px-1 ">
                    <div className="form-group">
                      <label className="font-weight-bold">کارتۆن</label>
                      <input
                        type="text"
                        disabled={del_dis == true ? true : null}
                        onChange={(e) => CartonChange(e)}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? edit == null
                              ? onSaveTable(event)
                              : updtae_product(edit._id, edit)
                            : null
                        }
                        value={karton}
                        name="karton"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-1 px-2 mt4">
                    {edit != null ? (
                      <button onClick={clear_edit} className="btn btn-primary">
                        <i className="fas fa-window-close"></i>
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-2 col-4 px-2 mt4">
                    <button
                      className="btn btn-dark p3 px-4"
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                      onClick={productpageminsone}
                    >
                      <i className="fas fa-caret-left f4"></i>
                    </button>
                    <button
                      className="btn btn-dark p3 px-4 ml3"
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                      onClick={productpageplusone}
                    >
                      <i className="fas fa-caret-right f4"></i>
                    </button>
                  </div>
                </div>
              </div>
              <ScroolTableAddPro />
              <div className="row px-2 tc">
                <div className="col-3"></div>{" "}
                <div className="col-3">
                  {" "}
                  <label className="font-weight-bold">فرۆشتن</label>
                  <input
                    type="text"
                    value={Number(
                      _.subtract(
                        _.sumBy(data, function (o) {
                          return o.numberOfCarton;
                        }),
                        Add_rasidkarton
                      )
                    ).toFixed(2)}
                    className="form-control text-right font-weight-bold"
                  />
                </div>
                <div className="col-3">
                  {" "}
                  <label className="font-weight-bold">کڕین</label>
                  <input
                    type="text"
                    value={Number(
                      _.sumBy(data, function (o) {
                        return o.numberOfCarton;
                      })
                    ).toFixed(2)}
                    className="form-control text-right font-weight-bold"
                  />
                </div>
                <div className="col-3"></div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default AddProductSecond;
